import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

export interface RentalGroupSuccessDialogData {
  title: string
  message: string
  image?: string
  steps?: string[]
  buttons: {
    label?: string
    classes: string
    icon?: string
    action?: () => void
  }[]
}

@Component({
  selector: 'app-rental-group-success-dialog',
  templateUrl: './rental-group-success-dialog.component.html',
  host: { class: 'modal-content' },
  styleUrls: ['./rental-group-success-dialog.component.scss'],
})
export class RentalGroupSuccessDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<RentalGroupSuccessDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RentalGroupSuccessDialogData
  ) {}

  close() {
    this.dialogRef.close()
  }

  onClick(btn: RentalGroupSuccessDialogData['buttons'][number]) {
    btn?.action?.()
    this.close()
  }
}
